import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SPEND_CATEGORIES } from 'api/react-query/keys'
import { deleteCategoryGroup } from 'SpendControl/endpoints'

export const useDeleteCategoryGroup = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => deleteCategoryGroup(id),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [SPEND_CATEGORIES] })
    },
  })
}
